module.exports = __webpack_public_path__ + "img/after5.38950293.png";